import { Button, dialog, printComponent } from "nq-component";
import CardView from "../../../../components/common/CardView";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import BasePage from "../../../../base/BasePage";
import { renderToStaticMarkup } from "react-dom/server";
import { formatDate } from "../../../../components/common/Converter";
import printContent from "./PrintContent";
import GenerateLeaveCard from "./GenerateLeaveCard";
import React from "react";
import { findObjectUseCase } from "../../../../usecases/object";

export default class LeaveCard extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      yearSelected: "",
      // periodSelected: "",
      leaveCard: [],
    };
    this.contractPDF = React.createRef();
  }

  handleYearChange(yearSelected) {
    this.setState({ yearSelected });
  }
  // handlePeriodChange(periodSelected) {
  //   this.setState({ periodSelected });
  // }

  dialogClose() {
    dialog.close();
  }

  async handlePrint() {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    const { object } = this.props;
    const printContentElement = GenerateLeaveCard(
      object,
      this.state.leaveCard,
      this.state.yearSelected
    );
    const printContentHTML = renderToStaticMarkup(printContentElement);

    iframeDoc.open();
    iframeDoc.write(
      `<html><head><title>Print DTR</title><style>
          body {
            font-family: Arial, sans-serif;
          }
          .print-content-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
          }
          .print-content {
            margin: 0;
            padding: 0;
          }
          @media print {
            th {
              font-weight: normal; 
            }
          }
          
          @page {
            size: auto;   /* auto is the initial value */
            margin: 0;     /* this affects the margin in the printer settings */
            visibility: hidden;
          }
        </style></head><body>`
    );
    iframeDoc.write("<div class='print-content-container'>");
    iframeDoc.write("<div class='print-content'>");
    iframeDoc.write(printContentHTML);
    iframeDoc.write("</div>");
    // iframeDoc.write("<div class='print-content'>");
    // iframeDoc.write(printContentHTML);
    // iframeDoc.write("</div>");
    iframeDoc.write("</div>");
    iframeDoc.write("</body></html>");
    iframeDoc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Remove the iframe after printing
    document.body.removeChild(iframe);
    // printComponent(this.contractPDF.current, "Tasks");
    dialog.close();
    this.props.closeGenerateLeaveCard();
  }

  async handleClickOk() {
    const startOfYear = new Date(
      `${this.state.yearSelected}-01-01T00:00:00.000Z`
    );
    const endOfYear = new Date(
      `${this.state.yearSelected}-12-31T23:59:59.999Z`
    );

    const leaveCard = await findObjectUseCase().execute("leave_card", {
      where: {
        "employee.id": this.props.object?.id,
        createdAt: {
          $gte: startOfYear,
          $lte: endOfYear,
        },
      },
    });
    this.setState({ leaveCard });

    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Are you sure you want to process this Leave Card?
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this.handlePrint()}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }
  render() {
    const isMobile = window.innerWidth <= 768;
    const startYear = 2019;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push(year.toString());
    }
    // const year = ["2024", "2023", "2022", "2021", "2020", "2019"];
    // const period = ["1st Semester", "2nd Semester"];
    return (
      <>
        <>
          {/* <div className="d-none">
            <div ref={this.contractPDF} id="contractPDF">
              <GenerateLeaveCard
                object={this.props.object}
                leaveRequest={this.state.leaveCard}
                yearSelected={this.state.yearSelected}
              />
            </div>
          </div> */}
          <div
            className="w-100 h-100 position-fixed end-0 start-0 overflow-y-auto d-flex justify-content-center align-items-center"
            style={{
              zIndex: 1050,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            }}
          >
            {/* Existing modal content */}
            <div
              className="w-100 d-flex column align-items-center"
              style={{
                maxHeight: "99%",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: isMobile ? "90%" : "40rem",
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleClickOk();
                    // this.handlePrint();
                  }}
                >
                  <CardView style={{ padding: 0 }}>
                    <h4 className="fs-6 fw-bold pt-3 ps-3">
                      Generate Leave Card
                    </h4>
                    <hr />
                    <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                      <div className="pb-4">
                        <label className="mb-2 fs-6">Year</label>
                        <SearchSelect
                          value={this.state.yearSelected}
                          onChange={this.handleYearChange.bind(this)}
                          required={true}
                          options={years.map((year) => ({
                            label: year,
                            value: year,
                          }))}
                        />
                      </div>

                      {/* <div className="pb-4">
                        <label className="mb-2 fs-6">Period</label>
                        <SearchSelect
                          value={this.state.periodSelected}
                          required={true}
                          onChange={this.handlePeriodChange.bind(this)}
                          options={period.map((type) => ({
                            label: type,
                            value: type,
                          }))}
                        />
                      </div> */}
                    </div>
                    <hr />
                    <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                      <Button
                        className="btn btn-light fs-sm"
                        type="button"
                        onClick={() => this.props.closeGenerateLeaveCard()}
                      >
                        Cancel
                      </Button>
                      <Button className="btn btn-primary" type="submit">
                        OK
                      </Button>
                    </div>
                  </CardView>
                </form>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}
